mutation migrationUpdatePositions( $hash: String, $user_id: String, $eth_address: String) {
    migrationUpdatePositions(hash: $hash, user_id: $user_id, eth_address: $eth_address)
}
